class MoreLessLayout extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector(".more-less-layout__content");
    this.button = this.querySelector("button");
    this.readMoreText = this.getAttribute("data-read-more-text") || "Read More";
    this.readLessText = this.getAttribute("data-read-less-text") || "Read Less";
    
    // Parse max lines, handling null/empty values
    const desktopAttr = this.getAttribute("data-max-lines-desktop");
    const mobileAttr = this.getAttribute("data-max-lines-mobile");
    
    console.log('Raw attributes:', { desktopAttr, mobileAttr });
    
    this.maxLinesDesktop = (desktopAttr && desktopAttr !== 'null' && desktopAttr !== '') ? parseInt(desktopAttr, 10) : null;
    this.maxLinesMobile = (mobileAttr && mobileAttr !== 'null' && mobileAttr !== '') ? parseInt(mobileAttr, 10) : null;
    this.expanded = false;
    
    console.log('Parsed values:', { maxLinesDesktop: this.maxLinesDesktop, maxLinesMobile: this.maxLinesMobile });
    
    // Only initialize if at least one max line value is set
    if (this.maxLinesDesktop !== null || this.maxLinesMobile !== null) {
      console.log('Initializing more-less layout');
      this.updateStyles();
      this.checkButtonVisibility();
      
      this.button.addEventListener("click", () => {
        this.toggleReadMore();
      });
    } else {
      // Hide button if no max lines are set
      if (this.button && this.button.closest('.more-less-layout__button')) {
        this.button.closest('.more-less-layout__button').classList.add('hidden');
      }
    }
  }

  updateStyles() {
    const maxLines = this.getMaxLines();
    if (maxLines !== null) {
      this.content.style.display = "-webkit-box";
      this.content.style.overflow = "hidden";
      this.content.style.webkitBoxOrient = "vertical";
      this.content.style.webkitLineClamp = maxLines;
    } else {
      this.content.style.display = "";
      this.content.style.overflow = "";
      this.content.style.webkitBoxOrient = "";
      this.content.style.webkitLineClamp = "";
    }
  }

  getMaxLines() {
    const isDesktop = window.matchMedia('(min-width: 1033px)').matches;
    if (isDesktop) {
      return this.maxLinesDesktop;
    } else {
      return this.maxLinesMobile;
    }
  }

  toggleReadMore() {
    if (this.expanded) {
      this.content.style.webkitLineClamp = this.getMaxLines();
      this.button.querySelector('span:not(.icon)').textContent = this.readMoreText;
    } else {
      this.content.style.webkitLineClamp = "unset";
      this.button.querySelector('span:not(.icon)').textContent = this.readLessText;
    }
    this.classList.toggle('expanded', !this.expanded);
    this.expanded = !this.expanded;
  }

  checkButtonVisibility() {
    const maxLines = this.getMaxLines();
    
    if (maxLines === null) {
      this.button.closest('.more-less-layout__button').classList.add('hidden');
      return;
    }
    
    const fullLines = this.getFullLineCount();
    console.log('fullLines:', fullLines, 'maxLines:', maxLines);
    this.button.closest('.more-less-layout__button').classList.toggle('hidden', fullLines <= maxLines);
  }

  getFullLineCount() {
    const originalClamp = this.content.style.webkitLineClamp;
    const originalDisplay = this.content.style.display;
    
    this.content.style.webkitLineClamp = 'unset';
    this.content.style.display = 'block';
    
    const style = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(style.lineHeight);
    const fullHeight = this.content.scrollHeight;
    
    this.content.style.webkitLineClamp = originalClamp;
    this.content.style.display = originalDisplay;
    
    console.log('lineHeight:', lineHeight, 'fullHeight:', fullHeight);
    return Math.round(fullHeight / lineHeight);
  }

  connectedCallback() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const maxLines = this.getMaxLines();
        
        if (maxLines === null && this.expanded) {
          this.expanded = false;
          this.classList.remove('expanded');
        }
        
        if (!this.expanded && !this.scrollToElement) {
          this.updateStyles();
          this.checkButtonVisibility();
        }
      }, 100);
    });
  }
}

customElements.define('more-less-layout', MoreLessLayout);
